
















































import Component from 'vue-class-component';
import { namespace } from 'vuex-class';
import { CreateRoleData } from '@/modules/backend/Dto/CreateRoleData';
import EditDialogWrapper from '@/layouts/EditDialogWrapper.vue';
import { Mixins, Ref } from 'vue-property-decorator';
import Mixin from '@/mixins/base';
import { ValidationObserver } from '@/plugins/vee-validate';

const RolesModule = namespace('dashboard/roles');

function clearForm(): { Name: string; RemovePersist: boolean; Title: string } {
  const defaultRole = {
    Name: '',
    RemovePersist: false,
    Title: ''
  };

  return Object.assign({}, defaultRole);
}

@Component({
  mixins: [Mixin],
  components: {
    'edit-dialog-wrapper': EditDialogWrapper
  }
})
export default class RoleCreateDialog extends Mixins(Mixin) {
  @Ref('observer')
  private readonly observer!: ValidationObserver;

  @RolesModule.Action('Create')
  private CreateRole!: (payload: CreateRoleData) => Promise<void>;

  private RoleForm = clearForm();

  private dialogOpenHandler(): void {
    this.observer.reset();
    this.RoleForm.Name = '';
    this.RoleForm.Title = '';
    this.RoleForm.RemovePersist = false;
    clearForm();
  }

  private async create(): Promise<void> {
    this.observer.reset();

    if (await this.observer.validate()) {
      await this.CreateRole({
        name: this.RoleForm.Name,
        title: this.RoleForm.Title
      });
    } else {
      throw new Error('Validation error');
    }
  }
}
